import React from "react";
import { Table, Text, Typography } from "antd";
import _ from "lodash";
import { Link } from "react-router-dom";

const columns = [
  {
    title: "Cold Call",
    dataIndex: "name",
  },
  {
    title: "Total Attempts",
    dataIndex: "total_attempts",
    sorter: {
      compare: (a, b) => a.total_attempts - b.total_attempts,
      multiple: 3,
    },
  },
  {
    title: "Answered",
    dataIndex: "answered",
    sorter: {
      compare: (a, b) => a.answered - b.answered,
      multiple: 1,
    },
  },
  {
    title: "Unanswered",
    dataIndex: "unanswered",
    sorter: {
      compare: (a, b) => a.unanswered - b.unanswered,
      multiple: 1,
    },
  },
  {
    title: "Unique Unanswered Attempt",
    dataIndex: "unique_unanswered_attempts",
    sorter: {
      compare: (a, b) =>
        a.unique_unanswered_attempts - b.unique_unanswered_attempts,
      multiple: 1,
    },
  },
  {
    title: "Unique Answered Attempt",
    dataIndex: "unique_answered_attempts",
  },
  {
    title: "Unique Attempt",
    dataIndex: "unique_attempts",
    sorter: {
      compare: (a, b) => a.unique_attempts - b.unique_attempts,
      multiple: 1,
    },
  },
  {
    title: "Total Talktime",
    dataIndex: "total_talk_time",
    sorter: {
      compare: (a, b) => a.total_talk_time - b.total_talk_time,
      multiple: 1,
    },
  },
];

const ColdCall = ({ callingData, loading }) => {
  const { Text } = Typography;
  const dataArray = [];
  const mappedData = _.get(callingData, ["statsByTag"], {});
  const uniqueCaseData = _.get(callingData, ["callByStatus"]);

  for (const key in mappedData) {
    if (mappedData.hasOwnProperty(key)) {
      dataArray.push({
        name: key,
        ...mappedData[key],
      });
    }
  }

  const tableData = dataArray?.map((item) => {
    return {
      total_attempts: item.total_attempts,
      name: item.name,
      answered: item.answered,
      unanswered: item.unanswered,
      unique_unanswered_attempts: item.unique_unanswered_attempts,
      unique_answered_attempts:
        item.unique_attempts - item.unique_unanswered_attempts,
      unique_attempts: item.unique_attempts,
      total_talk_time: item.total_talk_time,
    };
  });

  const expandedRowRenderTwo = (rowDataTwo) => {
    const mappedTableTwoData = rowDataTwo?.map((item) => ({
      ...item,
      phone: item?.case?.phone_number,
      name: item?.case?.first_name,
    }));

    const columns = [
      {
        title: "Name",
        dataIndex: "name",
        key: "tag",
        render: (text, record) => (
          <Link to={`/lead-details/${record.case_id}`}>{record.name}</Link>
        ),
      },
      {
        title: "Tag",
        dataIndex: "tag",
        key: "tag",
      },
      {
        title: "Phone",
        dataIndex: "phone",
        key: "case_id",
      },
    ];

    return (
      <Table
        columns={columns}
        dataSource={mappedTableTwoData}
        pagination={true}
        rowKey={(record, index) => index}
      />
    );
  };

  const expandedRowRender = (rowData) => {
    const rowDataTwo = [];

    for (let i in rowData) {
      rowDataTwo.push({ name: i, value: rowData[i].length });
    }

    const columns = [
      {
        title: "name",
        dataIndex: "name",
        key: "name",
      },
      {
        title: "Count",
        dataIndex: "value",
        key: "value",
      },
    ];

    return (
      <Table
        columns={columns}
        dataSource={rowDataTwo}
        expandable={{
          expandedRowRender: (record) => expandedRowRenderTwo(rowData[record.name]),
        }}
        rowKey={(record, index) => index}
        pagination={false}
      />
    );
  };

  return (
    <Table
      columns={columns}
      dataSource={tableData}
      expandable={{
        expandedRowRender: (record) => expandedRowRender(uniqueCaseData[record.name]),
        rowExpandable: (record) => !!uniqueCaseData[record.name],
      }}
      rowKey={(record) => record.name}
      loading={loading}
      summary={(pageData) => {
        const totals = tableData.reduce((acc, curr) => {
          Object.entries(curr).forEach(([key, value]) => {
            if (key !== "name" && key !== "total_talk_time") {
              acc[key] = (acc[key] || 0) + (value || 0);
            } else if (key === "total_talk_time" && typeof value === "string" && value.match(/^\d{2}:\d{2}:\d{2}$/)) {
              const [hoursStr, minutesStr, secondsStr] = value.split(":").map(Number);
              acc[key] = (acc[key] || 0) + (hoursStr * 3600 + minutesStr * 60 + secondsStr);
            }
          });
          return acc;
        }, {});
        

        return (
          <Table.Summary fixed className="bg-success-50">
            <Table.Summary.Row>
              <Table.Summary.Cell colSpan={2}>
                <Text strong>Total</Text>
              </Table.Summary.Cell>

              {Object.keys(totals)?.map((col) => (
                <Table.Summary.Cell key={col} colSpan={1}>
                  <Text strong>{totals[col]}</Text>
                </Table.Summary.Cell>
              ))}
            </Table.Summary.Row>
          </Table.Summary>
        );
      }}
    />
  );
};

export default ColdCall;
